import { useEffect, useState } from "react";
import { elementsIds } from "../../page.constant";
import { Header } from "./styles";

/**
 * FixedHeader component
 * This component is used to define elements to be fixed on top of the page
 * after the navBar component if present.
 * @warning this component has to be wrapped by a PageWrapper component.
 */
export const FixedHeader = ({ children, ...props }) => {
  const [stickyHeight, setSitckyHeight] = useState(0);

  useEffect(() => {
    const stickyElements = document.getElementsByClassName(elementsIds.STICKY);

    if (stickyElements && stickyElements.length) {
      /**
       * @observe StickyContainer element to define his height.
       * the height will be hidden when user bottom scroll the page.
       * @warning For now we supposed only one StickyContainer will be used per page.
       * @warning We don't handle more than one StickyContainer per page.
       */
      new ResizeObserver((entries) => {
        let height = 0;
        for (const entry of entries) {
          height += Math.floor(entry.contentRect.height);
        }
        if (stickyHeight !== height) {
          setSitckyHeight(height);
        }
      }).observe(stickyElements[0]);
    }
  }, []);

  return (
    <Header {...props} id={elementsIds.HEADER}>
      {children}
    </Header>
  );
};
